// extracted by mini-css-extract-plugin
export default {"wrapper":"dC-z","viewport":"eC-z","container":"fC-z","slide":"gC-z"};